<template>
    <div>
      <router-view></router-view>
    </div>
  </template>
  
  <script>
  export default {
    name: "videoIndex",
    data() {
      return {
      };
    },
  };
  </script>
  
  <style lang="less" scoped>
  
  </style>